import { DrillScoring } from '@core';

export const drillScoringShortMapper = (scoring: DrillScoring): string => {
  switch (scoring) {
    case DrillScoring.TimePerRep:
      return 'TPR';
    case DrillScoring.RepsOnly:
      return 'REPS';
    case DrillScoring.HitFactor:
      return 'HF';
  }
};
